'use strict';

namespace Core {
    class DestinationContentCard {
        // Attr
        model: Destinations.DestinationContentCard;
        header: string;

        constructor (
            private houseRecommender: any
        ) {
        }

        public trackClick() {
            this.houseRecommender.trackHouseClick(this.model);
        }

    }
    angular
        .module('core')
        .directive('destinationContentCard', (): ng.IDirective => {
            return {
                restrict: 'E',
                scope: {},
                controller: DestinationContentCard,
                controllerAs: 'dc',
                replace: true,
                bindToController: {
                    model: '=',
                    header: '@'
                },
                templateUrl: 'partials/home/directivetemplate?type=DestinationContentCard'
            };
        });
}
